import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  removeLayout as removeLayoutFromView
} from '../redux/view'

export default function * requestRemoveMyLayout (action) {
  const { id } = action.payload

  const optimisticAction = yield optimisticPut([
    removeLayoutFromView({
      id
    })
  ])

  try {
    yield call(apiAction, 'RemoveMyHomeLayout', {
      homeLayoutId: id
    })
  } finally {
    yield optimisticAction.revert()
  }
}
